import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddContactAddressComponent } from './add/add.component';
import { ApiService } from '../../services/api.service';
import { ContactAddressService } from '../../services/contactAddress.service';

@Component({
    selector: 'app-contact-addresses',
    templateUrl: './contact-addresses.component.html',
    styleUrls: ['./contact-addresses.component.scss'],
    standalone: false
})
export class ContactAddressesComponent implements OnInit {
  list: any;
  dialogConfig: MatDialogConfig;
  length = 1;
  constructor(
    private matDialog: MatDialog,
    private apiService: ApiService,
    private contactAddressService: ContactAddressService
  ) {
    this.list = [];
  }

  ngOnInit(): void {
    this.dialogConfig = new MatDialogConfig();
    this.getList();
  }

  getList() {
    var self = this;
    var reqparams = {};
    this.contactAddressService.getAddress(reqparams, {
      getResult(res) {
        self.contactAddressService.address = res.data;
        if (self.contactAddressService.address) {
          self.list.push(self.contactAddressService.address);
        }
      },
      getError(err) {
        console.log(err);
      },
    });
  }

  edit(model) {
    var self = this;
    var modelInEdit = model;
    this.dialogConfig = new MatDialogConfig();
    let dialogRef = this.matDialog.open(
      AddContactAddressComponent,
      {
        disableClose: true,
        data: { model: model }
      }
    );
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        if (value.edit) {
          for (var key in value.data) {
            model[key] = value.data[key];
          }
          self.contactAddressService.address = self.list[0];
        }
        if (value.delete) {
          self.list.splice(self.list.indexOf(modelInEdit), 1);
        }
      }
    });
  }

  addModal() {
    var self = this;
    let dialogRef = this.matDialog.open(
      AddContactAddressComponent,
      {
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        if (value.add) {
          var dataToAdd = value.data;
          //self.list.push(dataToAdd);
          self.contactAddressService.address = dataToAdd;
        }
      }
    });
  }

  openBox() {}

  showAll() {
    if (this.length === 1) {
      this.length = this.list.length;
    } else {
      this.length = 1;
    }
  }
}
